
















import { Component, Ref, Vue } from 'vue-property-decorator'
import { gsap } from 'gsap'

@Component
export default class ActionsDropdown extends Vue {
    @Ref() dropdown: HTMLDivElement
    dropdownVisible: boolean = false

    animateShow(element: HTMLDivElement, onComplete: () => void) {
        gsap.set(this.dropdown, {
            opacity: 0,
        })

        gsap.to(this.dropdown, {
            duration: .2,
            opacity: 1,
            onComplete,
        })
    }

    animateHide(element: HTMLDivElement, onComplete: () => void) {
        gsap.to(this.dropdown, {
            duration: .2,
            opacity: 0,
            onComplete,
        })
    }
}
